import { Sparkles } from "lucide-react";

/**
 * Contemplative monogram avatar for resonance figures.
 * No external image — we render initials in a gold ring with a small spark accent.
 * Prevents broken-image text from leaking on screens.
 */
export default function ResonanceAvatar({ name, size = 112 }) {
  const initials = (name || "·")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(w => w[0])
    .join("")
    .toUpperCase();

  const fontSize = Math.round(size * 0.36);
  const sparkSize = Math.max(10, Math.round(size * 0.13));

  return (
    <div
      className="relative rounded-full flex items-center justify-center overflow-hidden"
      style={{
        width: size,
        height: size,
        border: "1.5px solid var(--vedari-gold)",
        background:
          "radial-gradient(circle at 30% 25%, rgba(184,149,74,0.15), transparent 70%), rgba(184,149,74,0.06)",
      }}
      data-testid="resonance-avatar"
    >
      <span
        className="font-display tracking-wider"
        style={{ fontSize, color: "var(--vedari-gold)", lineHeight: 1 }}
      >
        {initials}
      </span>
      <Sparkles
        size={sparkSize}
        strokeWidth={1.6}
        className="absolute"
        style={{ top: size * 0.18, right: size * 0.18, color: "var(--vedari-gold)", opacity: 0.6 }}
      />
    </div>
  );
}
